<template>
  <a-modal v-model="modal" title="批量修改" width="450px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="最晚供应时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="lastSupplyDate"
        :rules="rules.lastSupplyDate"
      >
        <a-date-picker style="width: 100%" v-model="formData.lastSupplyDate" valueFormat="YYYY-MM-DD" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiScpCallManagerUpdate } from '@/api/scp/work-order-material/work-order-material'

export default {
  name: 'BatchEditDateModal',
  data() {
    return {
      modal: false,
      formData: {
        lastSupplyDate: ""
      },
      loading: false,
      rules: {
        lastSupplyDate: [{ required: true, message: ' ', trigger: 'change' }]
      },
      selectedRows: []
    }
  },
  methods: {
    moment,
    show (list) {
      this.selectedRows = list
      this.formData.lastSupplyDate = ""
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const ids = this.selectedRows.map(item => item.id)
          const params = { ids: ids, lastSupplyDate: this.formData.lastSupplyDate }
          this.loading = true;
          apiScpCallManagerUpdate(params).then(response => {
            if (response.code === 200) {
              this.modal = false
              this.$message.success('修改完成')
              this.$emit("successFun")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
